import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({}),
    $success(msg) {
      this.$snotify.success(msg);
    },
    /** Gets message from Axios error object . If optional msg is passed then that will be output
     * api errors should include expects error from backend returned json to be called `userMessage` or `message`
     */
    $error(axiosError, msg) {
      this.$snotify.error(axiosError.response ? this.getErrorMessage(axiosError.response) : 'something went wrong!');
    },

    getErrorMessage({ data }) {
      let userMessage = 'something went wrong!';
      if (data) {
        if(data.error) {
          userMessage = data.error.message;
        }
        if(data.errors) {
          userMessage = data.errors;
        }
      }
      return userMessage;
    },

    $warning(msg) {
      this.$snotify.warning(msg);
    }
  }
}
